import React, {Component} from "react";
import {
  Table,
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
  Col,
  Alert,
  InputGroup
}                         from "react-bootstrap";
import moment             from "moment";
import Pagination         from "react-js-pagination";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import debounce           from "lodash.debounce"

import { PHOENIXVOUCHER }      from "actions/const";

import {
  IS_VALID,
  IS_LENGTH_ZERO
}                         from "utils";

import Loader             from "../../Loader.js";

export default class View extends Component {
  constructor (props) {
    super(props);

    this.redeemClaimVoucherFormRef;

    this.state = {
      currentPage: 1,

      showModal: false,
      showModalView: false,

      formType: "",
      formTitle: "",
      selectedData: null,
      selectedDataPhoenixVoucherRedemption: null,

      showAlert: false,
      alertMessage: "",

      memberIds: [],
      cardTypes: [],
      startDate: "",
      endDate: ""
    };

    this.handlePaginate = this.handlePaginate.bind(this);
    this.renderModalButton = this.renderModalButton.bind(this);
    this.getPhoenixVoucherRedemptionLog_delayCallback = debounce(this.props.getPhoenixVoucherRedemptionLog, 1000);
  }

  handlePaginate (pageNumber) {
    let {
      memberIds,
      cardTypes,
      startDate,
      endDate
    } = this.state;

    this.setState({ currentPage: pageNumber }, () => {
      this.props.getPhoenixVoucherRedemptionLog(pageNumber, memberIds, cardTypes, startDate, endDate);
    });
  }

  renderModalButton () {
    let {
      currentPage,
      formType,
      selectedData,
      memberIds,
      cardTypes,
      startDate,
      endDate
    } = this.state;

    let {
      PhoenixVoucher
    } = this.props;

    let {
      isRedeemingEVoucher,
      isClaimingEVoucher,
      isUpdatingVisibility
    } = PhoenixVoucher;

    let buttons = [],
        buttonAction = (
          title = "REDEEM",
          action = () => redeemEVoucher(
              selectedData,
              () => {
                this.setState({
                  showModal: false,
                  formType: "",
                  formTitle: "",
                  selectedData: null,

                  showAlert: false,
                  alertMessage: ""
                });

                this.props.getPhoenixVoucherRedemptionLog(currentPage, memberIds, cardTypes, startDate, endDate);
              }
            )
          ) => (
          <Button
            bsStyle="primary"
            disabled={isRedeemingEVoucher || isClaimingEVoucher || isUpdatingVisibility}
            onClick={action}
            >
            {title}
          </Button>
        ),
        buttonClose = (
        <Button
          disabled={isRedeemingEVoucher || isClaimingEVoucher || isUpdatingVisibility}
          onClick={() => {
            this.setState({
              showModal: false,
              formType: "",
              formTitle: "",
              selectedData: null,

              showAlert: false,
              alertMessage: ""
            })
          }}>
          CLOSE
        </Button>
        );

    switch (formType.toUpperCase()) {
      case "REDEEM_VOUCHER":
        buttons.push(
          buttonAction(),
          buttonClose
        );
        break;
      case "CLAIM_VOUCHER":
        buttons.push(
          buttonAction(
            "CLAIM",
            () => {
              let redeemClaimVoucherFormRef = this.refs.redeemClaimVoucherFormRef;
              
              let password = (
                IS_VALID(redeemClaimVoucherFormRef) &&
                IS_VALID(redeemClaimVoucherFormRef.getPassword) ? (
                  redeemClaimVoucherFormRef.getPassword()
                ) : (
                  ""
                )
              );

              claimEVoucher(
                selectedData,
                password,
                (err) => {
                  if (err) {
                    this.setState({
                      showAlert: true,
                      alertMessage: typeof err.message === "string" ? err.message : JSON.stringify(err.message)
                    });
                  } else {
                    this.setState({
                      showModal: false,
                      formType: "",
                      formTitle: "",
                      selectedData: null,

                      showAlert: false,
                      alertMessage: ""
                    });

                    if (
                      IS_VALID(this.refs.viewVoucherFormRef) &&
                      IS_VALID(this.refs.viewVoucherFormRef.getData)
                    ) {
                      this.refs.viewVoucherFormRef.getData();
                    }
                  }
                }
              )
            }
          ),
          buttonClose
        );
        break;
      case 'VISIBILITY':
        buttons.push(
          buttonAction(
            (selectedData && selectedData.get('isHidden') ? 'UN' : '') + "HIDE",
            () => {
              updateEVoucherVisibility(selectedData, (err) => {
                if (err) {
                  this.setState({
                    showAlert: true,
                    alertMessage: typeof err.message === "string" ? err.message : JSON.stringify(err.message)
                  });
                } else {
                  this.setState({
                    showModal: false,
                    formType: "",
                    formTitle: "",
                    selectedData: null,

                    showAlert: false,
                    alertMessage: ""
                  });

                  if (
                    IS_VALID(this.refs.viewVoucherFormRef) &&
                    IS_VALID(this.refs.viewVoucherFormRef.getData)
                  ) {
                    this.refs.viewVoucherFormRef.getData();
                  }
                }
              });
            }
          ),
          buttonClose
        );
        break;
      default:
        buttons.push(
          buttonClose
        );
    }
    return buttons;
  }

  render () {
    let {
      currentPage,

      showModal,
      showModalView,

      formType,
      formTitle,
      selectedData,
      selectedDataPhoenixVoucherRedemption,

      showAlert,
      alertMessage,

      memberIds,
      cardTypes,
      startDate,
      endDate
    } = this.state;

    let {
      PhoenixVoucher,
      exportReport,
      loadOptions,
      accessible,

      getAllPhoenixVoucherRedemptionLog,

      actions
    } = this.props;

    let {
      isRedeemingEVoucher,
      isClaimingEVoucher,
      isUpdatingVisibility,
      isLoadingPhoenixVoucher,

      countType,
      isLoading,
      isExporting,
      tableData,
      totalCount,
      limit
    } = PhoenixVoucher;

    let tr = "",
        isViewed = countType === "VIEWED",
        isClaimed = countType === "CLAIMED",
        isRedeemed = countType === "REDEEMED",
        tdStyle = { whiteSpace: "nowrap" };

    let isHideFinanceData = false;

    let user = Parse.User.current();

    if (
      IS_VALID(user) &&
      IS_VALID(user.get("userType")) &&
      user.get("userType") === "PARTNER"
    ) {
      isHideFinanceData = typeof user.get("isHideFinanceData") === "boolean" ? user.get("isHideFinanceData") : false;
    }

    if (isLoading) {
      tr = (
        <tr>
          <td colSpan={15} style={{ textAlign: "center" }}>
            <i className="fa fa-spinner fa-3x fa-spin"></i>
          </td>
        </tr>
      );
    } else if (IS_LENGTH_ZERO(tableData)) {
      tr = (
        <tr>
          <td colSpan={15} style={{ color: '#808080', textAlign: "center" }}>
            No Data Available
          </td>
        </tr>
      );
    } else {
      tr = tableData.map((item) => {
        let dateColumnName = "createdAt";

        if (isClaimed) {
          dateColumnName = "dateClaimed";
        } else if (isRedeemed) {
          dateColumnName = "dateRedeemed";
        }

        return (
          <tr>
            <td style={tdStyle}>
              {IS_VALID(item.get("title")) ? (
                item.get("title")
              ) : IS_VALID(item.get("PhoenixVoucher"))  && IS_VALID(item.get("PhoenixVoucher").get("title")) ? (
                item.get("PhoenixVoucher").get("title")
              ) : (
                ""
              )}
            </td>
            <td style={tdStyle}>
              {IS_VALID(item.get("memberId")) ? item.get("memberId") : ""}
            </td>
            <td style={tdStyle}>
              {IS_VALID(item.get("cardType")) ? item.get("cardType") : ""}
            </td>
            {isClaimed || isRedeemed ? (
              <td style={tdStyle}>
                {IS_VALID(item.get("transactionId")) ? item.get("transactionId") : ""}
              </td>
            ) : (
              ""
            )}
            {isRedeemed ? (
              <td style={tdStyle}>
                {IS_VALID(item.get("User")) && IS_VALID(item.get("User").get("name")) ? item.get("User").get("name") : ""}
              </td>
            ) : (
              ""
            )}
            {isRedeemed ? (
              <td style={tdStyle}>
                {IS_VALID(item.get("deviceID")) ? item.get("deviceID") : ""}
              </td>
            ) : (
              ""
            )}
            <td style={tdStyle}>
              {IS_VALID(item.get(dateColumnName)) ? moment(item.get(dateColumnName)).format("MM/DD/YYYY hh:mm:ss A") : ""}
            </td>
            {isRedeemed ? (
              <td style={tdStyle}>
                {IS_VALID(item.get("costCenter")) ? (
                  item.get("costCenter")
                ) : (
                  ""
                )}
              </td>
            ) : (
              ""
            )}
            {isViewed || isClaimed ? (
              <td>
                {isViewed ? (
                  <a
                    href="javascript:void(0)"
                    style={{ textDecoration: "underline" }}
                    onClick={() => {
                      this.setState({
                        showModalView: true,
                        selectedDataPhoenixVoucherRedemption: item
                      })
                    }}
                    >
                    View Vouchers
                  </a>
                ) : isClaimed ? (
                  (item.get("status") || "") === "CLAIMED" && accessible("MANUAL REDEEM") === "" ? (
                    <a
                      href="javascript:void(0)"
                      style={{ textDecoration: "underline" }}
                      onClick={() => {
                        this.setState({
                          showModal: true,
                          formType: "REDEEM_VOUCHER",
                          formTitle: "REDEEM VOUCHER",
                          selectedData: item
                        });
                      }}
                      >
                      Redeem
                    </a>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </td>
            ) : (
              ""
            )}
          </tr>
        );
      })
    }

    let paginationProps = {
      activePage: currentPage,
      itemsCountPerPage: limit,
      totalItemsCount: totalCount,
      pageRangeDisplayed: 5,
      onChange: this.handlePaginate
    };

    return (
      <div>
        <h3 style={{ marginTop: "0px" }}>{countType === "VIEWED" ? "ENROLLED" : countType} LOG</h3>
        <Button
          bsStyle="primary"
          disabled={isExporting}
          onClick={() => exportReport(memberIds, cardTypes, startDate, endDate)}
          >
          {isExporting ? <span><i className="fa fa-spinner fa-spin"/>&nbsp;</span> : ""}EXPORT
        </Button>
        <br/>
        <br/>
        <Row>
          <Col md={memberIds.length < 5 ? 3 : 12}
            sm={12}
          >
            <FormGroup>
              <ControlLabel>Member ID</ControlLabel>
              <Select.Async
                 multi={true}
                placeholder="Select or Search..."
                loadOptions={(input, cb) => loadOptions(input, cb)}
                value={memberIds}
                onChange={(value) => {
                  this.setState({ memberIds: value });

                  this.props.getPhoenixVoucherRedemptionLog(currentPage, value, cardTypes, startDate, endDate);
                }}
              />
            </FormGroup>
          </Col>
          <Col md={3}
            sm={12}
          >
            <FormGroup>
                <ControlLabel>Card Type</ControlLabel>
                <Select.Async
                  multi={true}
                  placeholder="Select or Search..."
                  loadOptions={(input, cb) => loadOptions(input, cb, "VoucherCardType")}
                  value={cardTypes}
                  onChange={(value) => {
                    this.setState({ cardTypes: value });

                    this.props.getPhoenixVoucherRedemptionLog(currentPage, memberIds, value);
                  }}
                />
              </FormGroup>
          </Col>
          <Col md={6}
            sm={12}
          >
            <FormGroup>
                <ControlLabel>
                  {!isClaimed && !isRedeemed ?
                    "Enrolled "
                    : isRedeemed ?
                    "Redeemed "
                    : "Claimed "
                  }
                  Timestamp
                </ControlLabel>
                <InputGroup>
                  <DateTime
                    dateFormat="MMM DD, YYYY"
                    timeFormat="hh:mm A"
                    value={startDate}
                    onChange={(datetime) => {
                      this.setState({ startDate: datetime });

                      this.getPhoenixVoucherRedemptionLog_delayCallback(currentPage, memberIds, cardTypes, datetime, endDate);
                    }}
                    inputProps={{
                      placeholder: "Start Date",
                      style: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                      }
                    }}
                    />
                  <InputGroup.Addon>TO</InputGroup.Addon>
                  <DateTime
                    dateFormat="MMM DD, YYYY"
                    timeFormat="hh:mm A"
                    value={endDate}
                    onChange={(datetime) => {
                      this.setState({ endDate: datetime });

                      this.getPhoenixVoucherRedemptionLog_delayCallback(currentPage, memberIds, cardTypes, startDate, datetime);
                    }}
                    inputProps={{
                      placeholder: "End Date",
                      style: {
                        position: "initial",
                        borderRadius: "0 4px 4px 0"
                      }
                    }}
                    />
                </InputGroup>
              </FormGroup>
          </Col>
        </Row>
        <Table striped bordered condensed hover responsive>
          <thead>
            <tr>
              <td style={tdStyle}>Calypso Voucher Title</td>
              <td style={tdStyle}>Member ID</td>
              <td style={tdStyle}>Card Type</td>
              {isClaimed || isRedeemed ? (
                <td style={tdStyle}>Transaction ID</td>
              ) : (
                ""
              )}
              {isRedeemed ? (
                <td style={tdStyle}>EV Scanner User</td>
              ) : (
                ""
              )}
              {isRedeemed ? (
                <td style={tdStyle}>Device ID</td>
              ) : (
                ""
              )}
              <td style={tdStyle}>
                {!isClaimed && !isRedeemed ?
                  "Enrolled "
                  : isRedeemed ?
                  "Redeemed "
                  : "Claimed "
                }
                Timestamp
              </td>
              {isRedeemed ? (
                <td style={tdStyle}>Outlet Name</td>
              ) : (
                ""
              )}
              {isViewed || isClaimed ? (
                <td>Actions</td>
              ) : (
                ""
              )}
            </tr>
          </thead>
          <tbody>
            {tr}
          </tbody>
        </Table>
        <div>Total Records: {totalCount}</div>
        <Pagination {...paginationProps}/>
        <Modal
          show={showModal}
          onHide={() => {
            if (!isRedeemingEVoucher || isClaimingEVoucher || isUpdatingVisibility) {
              this.setState({
                showModal: false,
                formType: "",
                formTitle: "",
                selectedData: null,

                showAlert: false,
                alertMessage: ""
              });
            }
          }}
          >
          <Modal.Header closeButton>
            {formTitle}
          </Modal.Header>
          <Modal.Body>
            {formType !== 'VISIBILITY' &&
            <RedeemClaimVoucherForm
              ref={"redeemClaimVoucherFormRef"}
              {...{
                formType,
                isRedeemingEVoucher,
                isClaimingEVoucher,
                isClaimed,
                isRedeemed,
                selectedData,

                showAlert,
                alertMessage,
                onAlertDismiss: () => {
                  this.setState({
                    showAlert: false,
                    alertMessage: ""
                  });
                },

                isHideFinanceData
              }}
            />
            }
            {formType === 'VISIBILITY' &&
              <div>
              <Loader loading={isUpdatingVisibility} />
              <p>Are you sure you want to {selectedData && selectedData.get('isHidden') ? 'un' : ''}hide this voucher?</p>
              </div>
            }
          </Modal.Body>
          <Modal.Footer>
              {this.renderModalButton()}
          </Modal.Footer>
        </Modal>
        <Modal
          bsSize='lg'
          show={showModalView}
          onHide={() => {
            if (!isLoadingPhoenixVoucher) {
              this.setState({
                showModalView: false,
                selectedDataPhoenixVoucherRedemption: null
              });
            }
          }}
          >
          <Modal.Header closeButton>
            VIEW VOUCHER
          </Modal.Header>
          <Modal.Body>
            {showModalView ? (
              <ViewVoucherForm
                ref={"viewVoucherFormRef"}
                {...{
                  selectedData: selectedDataPhoenixVoucherRedemption,
                  onClaimClick: (item) => {
                    this.setState({
                      showModal: true,
                      formType: "CLAIM_VOUCHER",
                      formTitle: "CLAIM VOUCHER",
                      selectedData: item
                    })
                  },
                  onVisibilityChangeClick: (item) => {
                    this.setState({
                      showModal: true,
                      formType: "VISIBILITY",
                      formTitle: (item.get('isHidden') ? 'UN' : '') + "HIDE VOUCHER",
                      selectedData: item
                    })
                  },

                  getAllPhoenixVoucherRedemptionLog,
                  accessible,
                  actions
                }}
              />
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={isLoadingPhoenixVoucher}
              onClick={() => {
                this.setState({
                  showModalView: false,
                  selectedDataPhoenixVoucherRedemption: null
                });
              }}>
              CLOSE
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  componentDidMount() {
    this.props.getPhoenixVoucherRedemptionLog();
  }
}

class RedeemClaimVoucherForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      password: ""
    };

    this.getPassword = this.getPassword.bind(this);
  }

  getPassword () {
    return this.state.password;
  }

  render () {
    let {
      formType,
      isRedeemingEVoucher,
      isClaimingEVoucher,
      isClaimed,
      isRedeemed,
      selectedData,

      showAlert,
      alertMessage,
      onAlertDismiss,

      isHideFinanceData
    } = this.props;

    let isClaimForm = formType === "CLAIM_VOUCHER";
    
    let hasRequiredEarningAmount = false,
        hasPointsDeduction = false;

    if (selectedData) {
      let _evoucher = selectedData.get("PhoenixVoucher"),
      _pointType = _evoucher.get("pointType"),
      _requiredEarningAmount = _evoucher.get("requiredEarningAmount"),
      _deductPointType = _evoucher.get("deductPointType"),
      _deductPointAmount = _evoucher.get("deductPointAmount");
      
      if (
        IS_VALID(_pointType) &&
        IS_VALID(_requiredEarningAmount) &&
        _requiredEarningAmount > 0
      ) {
        hasRequiredEarningAmount = true;
      }

      if (
        IS_VALID(_deductPointType) &&
        IS_VALID(_deductPointAmount) &&
        _deductPointAmount > 0
      ) {
        hasPointsDeduction = true;
      }
    }

    return (
      <div>
        <Loader loading={isRedeemingEVoucher || isClaimingEVoucher} />
        {selectedData !== null ? (
          <Table striped bordered condensed hover responsive>
            <tbody>
              <tr>
                <td>Calypso Voucher Title</td>
                <td>
                  {IS_VALID(selectedData.get("title")) ? (
                    selectedData.get("title")
                  ) : IS_VALID(selectedData.get("PhoenixVoucher"))  && IS_VALID(selectedData.get("PhoenixVoucher").get("title")) ? (
                    selectedData.get("PhoenixVoucher").get("title")
                  ) : (
                    ""
                  )}
                </td>
              </tr>
              <tr>
                <td>Member ID</td>
                <td>
                {IS_VALID(selectedData.get("memberId")) ? selectedData.get("memberId") : ""}
                </td>
              </tr>
              <tr>
                <td>Card Type</td>
                <td>
                  {IS_VALID(selectedData.get("cardType")) ? selectedData.get("cardType") : ""}
                </td>
              </tr>
              {!isClaimForm ? (
                <tr>
                  <td>Transaction ID</td>
                  <td>
                    {IS_VALID(selectedData.get("transactionId")) ? selectedData.get("transactionId") : ""}
                  </td>
                </tr>
              ) : (
                ""
              )}
              <tr>
                <td>Status</td>
                <td>
                  {IS_VALID(selectedData.get("status")) ? selectedData.get("status") : ""}
                </td>
              </tr>
              <tr>
                <td>
                  {!isClaimed && !isRedeemed ?
                    "Enrolled "
                    : isRedeemed ?
                    "Redeemed "
                    : "Claimed "
                  }
                  Timestamp
                </td>
                <td>
                  {IS_VALID(selectedData.get(isClaimed ? "dateClaimed" : isRedeemed ? "dateRedeemed" : "createdAt")) ? moment(selectedData.get(isClaimed ? "dateClaimed" : isRedeemed ? "dateRedeemed" : "createdAt")).format("MM/DD/YYYY hh:mm:ss A") : ""}
                </td>
              </tr>
              {!isClaimForm ? (
                [
                  <tr>
                    <td>Expired Timestamp</td>
                    <td>
                      {IS_VALID(selectedData.get("voucherExpiration")) ? moment(selectedData.get("voucherExpiration")).format("MM/DD/YYYY hh:mm:ss A") : ""}
                    </td>
                  </tr>,
                  !isHideFinanceData ? (
                    <tr>
                      <td>Budget Amount</td>
                      <td>
                        {IS_VALID(selectedData.get("amount")) ? (
                          selectedData.get("amount")
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ) : (
                    ""
                  ),
                  !isHideFinanceData ? (
                    <tr>
                      <td>Point Deduction</td>
                      <td>
                        {IS_VALID(selectedData.get("deductedPointAmount")) && IS_VALID(selectedData.get("deductPointType")) ? (
                        `${selectedData.get("deductedPointAmount")} ${selectedData.get("deductPointType")}`
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  )  : (
                    ""
                  ),
                  !isHideFinanceData ? (
                    <tr>
                      <td>Promo Owner Cost Center</td>
                      <td>
                        {IS_VALID(selectedData.get("promoOwnerCostCenter")) ? (
                          selectedData.get("promoOwnerCostCenter")
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  )  : (
                    ""
                  ),
                  !isHideFinanceData ? (
                    <tr>
                      <td>Promo Category</td>
                      <td>
                        {IS_VALID(selectedData.get("promoCategory")) && IS_VALID(selectedData.get("promoCategory").get("name"))? (
                          selectedData.get("promoCategory").get("name")
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  )  : (
                    ""
                  ),
                  !isHideFinanceData ? (
                    <tr>
                      <td>NNSL Amount</td>
                      <td>
                        {IS_VALID(selectedData.get("nnsl_amount")) ? (
                          selectedData.get("nnsl_amount")
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  )  : (
                    ""
                  ),
                  !isHideFinanceData ? (
                    <tr>
                      <td>NNC Amount</td>
                      <td>
                        {IS_VALID(selectedData.get("nnc_amount")) ? (
                          selectedData.get("nnc_amount")
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  )  : (
                    ""
                  )
                ]
              ) : (
                ""
              )}
            </tbody>
          </Table>
        ) : (
          ""
        )}
        <p>Are you sure you want to {isClaimForm ? "claim" : "redeem"} this voucher?</p>
        {isClaimForm ? (
          <Row>
            <Col md={4} mdOffset={4}>
              <FormGroup>
                <ControlLabel>Member PIN {hasPointsDeduction ? <span style={{ color: "red" }}>*</span> : ""}</ControlLabel>
                <FormControl
                  disabled={!hasPointsDeduction}
                  type="password"
                  value={this.state.password}
                  placeholder="Enter Member PIN"
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
        ) : (
          ""
        )}
        {showAlert ? (
          <Alert bsStyle="danger" onDismiss={onAlertDismiss}>
            <h4>{alertMessage}</h4>
          </Alert>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ViewVoucherForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isLoading: false,
      data: [],
      currentPage: 1,
      totalCount: 0
    };

    this.getData = this.getData.bind(this);
    this.handlePaginate = this.handlePaginate.bind(this);
  }

  getData (currentPage = 1) {
    let {
      selectedData,
      getAllPhoenixVoucherRedemptionLog,
      actions
    } = this.props;

    this.setState({
      currentPage: currentPage,
      isLoading: true
    });

    actions.setValue("PHOENIXVOUCHER", { isLoadingPhoenixVoucher: true });

    getAllPhoenixVoucherRedemptionLog(selectedData, currentPage)
    .then(([ data, count ]) => {
      this.setState({
        isLoading: false,
        data,
        totalCount: count
      });

      actions.setValue("PHOENIXVOUCHER", { isLoadingPhoenixVoucher: false });
    })
    .catch((err) => {
      this.setState({
        isLoading: false,
        data: [],
        totalCount: 0
      });

      actions.setValue("PHOENIXVOUCHER", { isLoadingPhoenixVoucher: false });
    });
  }

  handlePaginate (pageNumber) {
    this.getData(pageNumber);
  }

  render () {
    let {
      isLoading,
      data,
      currentPage,
      totalCount
    } = this.state;

    let {
      selectedData,
      onClaimClick,
      onVisibilityChangeClick,
      accessible
    } = this.props;

    let tr = "";

    if (isLoading) {
      tr = (
        <tr>
          <td colSpan={15} style={{ textAlign: "center" }}>
            <i className="fa fa-spinner fa-3x fa-spin"></i>
          </td>
        </tr>
      );
    } else if (IS_LENGTH_ZERO(data)) {
      tr = (
        <tr>
          <td colSpan={15} style={{ color: '#808080', textAlign: "center" }}>
            No Data Available
          </td>
        </tr>
      );
    } else {
      tr = data.map((item) => {
        return (
          <tr>
            <td>{IS_VALID(item.get("transactionId")) ? item.get("transactionId") : ""}</td>
            <td>{IS_VALID(item.get("dateRedeemed")) ? moment(item.get("dateRedeemed")).format("MM/DD/YYYY hh:mm:ss A") : ""}</td>
            <td>{item.get("remarks")}</td>
            <td>{IS_VALID(item.get("createdAt")) ? moment(item.get("createdAt")).format("MM/DD/YYYY hh:mm:ss A") : ""}</td>
            <td>
            </td>
          </tr>
        );
      });
    }

    let paginationProps = {
      activePage: currentPage,
      itemsCountPerPage: 10,
      totalItemsCount: totalCount,
      pageRangeDisplayed: 5,
      onChange: this.handlePaginate
    };
    
    return (
      <div>
        <Table striped bordered condensed hover responsive>
          <tbody>
            <tr>
              <td>Calypso Voucher Title</td>
              <td>
                {IS_VALID(selectedData.get("title")) ? (
                  selectedData.get("title")
                ) : IS_VALID(selectedData.get("PhoenixVoucher"))  && IS_VALID(selectedData.get("PhoenixVoucher").get("title")) ? (
                  selectedData.get("PhoenixVoucher").get("title")
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td>Member ID</td>
              <td>
               {IS_VALID(selectedData.get("memberId")) ? selectedData.get("memberId") : ""}
              </td>
            </tr>
            <tr>
              <td>Card Type</td>
              <td>
                {IS_VALID(selectedData.get("cardType")) ? selectedData.get("cardType") : ""}
              </td>
            </tr>
            <tr>
              <td>Enrolled Timestamp</td>
              <td>
               {IS_VALID(selectedData.get("createdAt")) ? moment(selectedData.get("createdAt")).format("MM/DD/YYYY hh:mm:ss A") : ""}
              </td>
            </tr>
          </tbody>
        </Table>

        <h4>Vouchers</h4>

        <Table striped bordered condensed hover responsive>
          <thead>
            <tr>
              <td>Transaction ID</td>
              <td>Date Redeemed</td>
              <td>Remarks</td>
              <td>Created At</td>
              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            {tr}
          </tbody>
        </Table>
        <div>Total Records: {totalCount}</div>
        <Pagination {...paginationProps}/>
      </div>
    );
  }

  componentDidMount () {
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./components/PhoenixVoucher/FormContainer/View.js